/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { onMounted, onBeforeMount } from 'vue';
import { on, off } from '../utils/dom.mjs';
import { i as isString_1 } from '../_chunks/dep-b390ff23.mjs';
import { CHECKED_CODE_REG } from '../checkbox/hooks/useKeyboard.mjs';
import '../_chunks/dep-34428f12.mjs';
import '../_chunks/dep-1f286011.mjs';
import '../_chunks/dep-1c40d002.mjs';
import '../_chunks/dep-8a0ff305.mjs';
import '../_chunks/dep-3ced59c9.mjs';
import '../_chunks/dep-e9ff4ce8.mjs';
import '../utils/easing.mjs';
import '../_chunks/dep-c54c9f32.mjs';
import '../_chunks/dep-61150968.mjs';

function useKeyboard(radioGroupRef, setInnerValue) {
  var checkRadioInGroup = function checkRadioInGroup(e) {
    var isCheckedCode = CHECKED_CODE_REG.test(e.key) || CHECKED_CODE_REG.test(e.code);
    if (isCheckedCode) {
      e.preventDefault();
      var inputNode = e.target.querySelector("input");
      var data = inputNode.dataset;
      if (inputNode.checked && data.allowUncheck) {
        setInnerValue(void 0, {
          e: e
        });
      } else {
        var value = !isNaN(Number(data.value)) ? Number(data.value) : data.value;
        value = isString_1(value) && {
          "true": true,
          "false": false
        }[value] || value;
        value = isString_1(value) && value[0] === "'" ? value.replace(/'/g, "") : value;
        setInnerValue(value, {
          e: e
        });
      }
    }
  };
  onMounted(function () {
    on(radioGroupRef.value, "keydown", checkRadioInGroup);
  });
  onBeforeMount(function () {
    off(radioGroupRef.value, "keydown", checkRadioInGroup);
  });
}

export { useKeyboard as default };
//# sourceMappingURL=useKeyboard.mjs.map
